import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const updateIntegrationToolParamsSchema = z.object({
  type: createEnum(["BlueYonder"]),
});

export type UpdateIntegrationToolParams = z.infer<
  typeof updateIntegrationToolParamsSchema
>;
